/**
 *
 * @module customerServiceClientConfiguration
 *
 */

import ServiceClientConfiguration from './../configuration/serviceClientConfiguration';

/**
 *
 * @class CustomerServiceClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc Provides configuration information used by the CustomerServiceClient.
 *
 */
export default class CustomerServiceClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/customerService/customerServiceClientConfiguration.js